<h2 mat-dialog-title>{{ esEdicionMaster ? 'Editar póliza' : (esEdicion ? 'Editar contratantes' : 'Cargar póliza') }}</h2>

<fuse-alert
    class="mx-6 mb-2"
    *ngIf="flashMessage"
    [type]="flashMessage.type"
    [appearance]="'outline'"
    [showIcon]="true"
    [dismissible]="false">
    {{ flashMessage.message }}
</fuse-alert>

<fuse-alert
    class="mx-6 mb-2"
    *ngIf="mostrarAvisoExtraccionFallida"
    type="error"
    [appearance]="'outline'"
    [showIcon]="true"
    [dismissible]="true"
    (dismissedChanged)="mostrarAvisoExtraccionFallida = false">
    No fue posible obtener todos los valores del documento Póliza. Verifica que sea el PDF correcto e ingresa los datos manualmente.
</fuse-alert>

<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 px-5 pt-4">

            <!-- Archivo PDF (alta, o edición MASTER donde el reemplazo es opcional) -->
            <mat-form-field class="w-full" *ngIf="!esEdicion || esEdicionMaster">
                <mat-label>Póliza .pdf</mat-label>
                <ngx-mat-file-input formControlName="file" accept=".pdf"
                                    placeholder="Archivo de póliza">
                </ngx-mat-file-input>
                <mat-progress-spinner *ngIf="isExtractingPdf"
                                      matSuffix
                                      [diameter]="20"
                                      [mode]="'indeterminate'"
                                      class="mr-1">
                </mat-progress-spinner>
                <mat-hint *ngIf="isExtractingPdf">Extrayendo datos del PDF…</mat-hint>
                <mat-error *ngIf="form.get('file')?.hasError('required')">
                    El archivo es <strong>obligatorio</strong>
                </mat-error>
                <mat-error *ngIf="form.get('file')?.hasError('maxContentSize')">
                    El archivo no puede pesar más de <strong>10 MB</strong>
                </mat-error>
            </mat-form-field>

            <!-- Número de póliza -->
            <mat-form-field class="w-full">
                <mat-label>Número de póliza</mat-label>
                <input matInput formControlName="numeroPoliza" placeholder="Ej. POL-2024-001"/>
                <mat-error *ngIf="form.get('numeroPoliza')?.hasError('required')">
                    El número de póliza es obligatorio
                </mat-error>
            </mat-form-field>

            <!-- Compañía Afianzadora -->
            <mat-form-field class="w-full">
                <mat-label>Compañía Afianzadora</mat-label>
                <input matInput formControlName="aseguradora" placeholder="Ej. GNP, AXA, Chubb"/>
                <mat-error *ngIf="form.get('aseguradora')?.hasError('required')">
                    La compañía afianzadora es obligatoria
                </mat-error>
            </mat-form-field>

            <!-- Monto -->
            <mat-form-field class="w-full">
                <mat-label>Monto</mat-label>
                <span matPrefix>$&nbsp;</span>
                <input matInput type="number" formControlName="monto"
                       placeholder="Ej. 250000.00" min="0.01" step="0.01"
                       [max]="9999999999999"/>
                <mat-error *ngIf="form.get('monto')?.hasError('required')">
                    El monto es obligatorio
                </mat-error>
                <mat-error *ngIf="form.get('monto')?.hasError('min')">
                    El monto debe ser mayor a cero
                </mat-error>
                <mat-error *ngIf="form.get('monto')?.hasError('max')">
                    El monto no puede exceder $9,999,999,999,999.00
                </mat-error>
            </mat-form-field>

            <!-- Vigencia inicio -->
            <mat-form-field class="w-full">
                <mat-label>Vigencia inicio</mat-label>
                <input matInput [matDatepicker]="pickerInicio" formControlName="vigenciaInicio"/>
                <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                <mat-datepicker #pickerInicio></mat-datepicker>
                <mat-error *ngIf="form.get('vigenciaInicio')?.hasError('required')">
                    La fecha de inicio es obligatoria
                </mat-error>
            </mat-form-field>

            <!-- Vigencia fin -->
            <mat-form-field class="w-full">
                <mat-label>Vigencia fin</mat-label>
                <input matInput [matDatepicker]="pickerFin" formControlName="vigenciaFin"/>
                <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
                <mat-datepicker #pickerFin></mat-datepicker>
                <mat-error *ngIf="form.get('vigenciaFin')?.hasError('required')">
                    La fecha de fin es obligatoria
                </mat-error>
                <mat-error *ngIf="form.get('vigenciaFin')?.hasError('vigenciaVencida')">
                    La fecha de fin debe ser <strong>futura</strong>
                </mat-error>
            </mat-form-field>

            <!-- Contratantes -->
            <mat-form-field class="w-full">
                <mat-label>Contratantes</mat-label>
                <mat-select multiple formControlName="contratanteIds">
                    <mat-option *ngFor="let c of contratantesDisponibles" [value]="c.id">{{ c.name }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('contratanteIds')?.hasError('required') || form.get('contratanteIds')?.hasError('minLengthArray')">
                    Debe seleccionar al menos un contratante
                </mat-error>
            </mat-form-field>

            <!-- Pagada -->
            <div class="flex items-center">
                <mat-checkbox formControlName="pagada" color="primary">Pagada</mat-checkbox>
            </div>

            <mat-error class="sm:col-span-2" *ngIf="form.hasError('fechaRangeInvalid') && form.get('vigenciaFin')?.touched">
                La fecha de fin debe ser posterior a la fecha de inicio
            </mat-error>

        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancelar()" [disabled]="enviando || isExtractingPdf">Cancelar</button>
    <button
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        [disabled]="enviando || isExtractingPdf || form.invalid">
        {{ enviando ? 'Guardando...' : (esEdicion ? 'Guardar' : 'Cargar póliza') }}
    </button>
</mat-dialog-actions>
